// Merge Views
import mainVideoView from 'Modules/video/views/main/lan/es';
import eventsTabView from 'Modules/video/views/main/.components/events/lan/es';
import clipsTabView from 'Modules/video/views/main/.components/clips/lan/es';
import advancedFilters from 'Modules/video/views/main/.components/advancedFilters/lan/es';
import videoDetailView from 'Modules/video/views/videoDetail/lan/es';
import manageCamerasView from 'Modules/video/views/manageCamerasTab/lan/es';

let locales = {};

locales = {
  ...locales,
  ...mainVideoView,
  ...clipsTabView,
  ...eventsTabView,
  ...advancedFilters,
  ...videoDetailView,
  ...manageCamerasView
};

export default locales;
